import React from 'react';
import FullScreenDataContainer
  from 'Components/ComponentLibrary/Components/Uncategorized/DataContainer/FullScreenDataContainer';
import useHomeContext from 'Context/HomeContext';
import NullComponent from 'Components/UI/NullComponent';
import PropTypes from 'prop-types';

const HomeContainer = ({ Component }) => {
  const {
    homeResource,
    isInitializing,
  } = useHomeContext();

  return (
    <FullScreenDataContainer
      component={Component}
      componentProps={{
        homeResource,
      }}
      skeleton={NullComponent}
      loading={isInitializing}
    />
  );
};

HomeContainer.propTypes = {
  Component: PropTypes.func.isRequired,
};

export default HomeContainer;
